import { MultiplayerStateManagerError } from "@noya-app/state-manager";
import * as React from "react";

export const ErrorOverlay = React.memo(function ErrorOverlay({
  error,
}: {
  error: MultiplayerStateManagerError;
}) {
  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        maxWidth: "80%",
        width: "fit-content",
        padding: "12px 20px",
        background: "white",
        color: "black",
        zIndex: 10000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderRadius: "4px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontFamily:
          "'__Inter_6b0edc', '__Inter_Fallback_6b0edc', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "19px",
      }}
    >
      {error.reason === "schemaMigration" ? (
        <>
          <p>
            An updated version of Noya is available. Please reload the page to
            continue.
          </p>
        </>
      ) : (
        <>
          <p>
            An error occurred:{" "}
            <code
              style={{
                background: "rgba(255, 0, 0, 0.1)",
                color: "rgba(255, 0, 0, 0.5)",
                padding: "2px 4px",
                borderRadius: "4px",
              }}
            >
              {error.reason}
            </code>
            . Please reload the page to continue.
            <br />
            <br />
            If this happens repeatedly, please get in touch and the Noya team
            can help.
          </p>
        </>
      )}
      <div
        style={{
          height: "1px",
          background: "rgba(0, 0, 0, 0.1)",
          margin: "12px -20px",
        }}
      />
      <button
        style={{
          background: "black",
          color: "white",
          padding: "8px 16px",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 700,
          lineHeight: "19px",
        }}
        onClick={() => {
          window.location.reload();
        }}
      >
        Reload
      </button>
    </div>
  );
});
